export const loadStylesheet = (doc: Document) => (stylesheetSrc: string) =>
  new Promise(resolve => {
    const stylesheet = doc.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = stylesheetSrc;
    stylesheet.onload = resolve;
    doc.head.appendChild(stylesheet);
  });


export const loadScript =
  (doc: Document) =>
  async (src: string, properties: Record<string, any> = { async: true }): Promise<void> =>
    new Promise((resolve, reject) => {
      if (!src) return reject('Please provide script source');

      const script = doc.createElement<'script'>('script');

      for (const { key, value } of Object.values(properties)) {
        script[key] = value;
      }
      script.src = src;
      script.onload = () => resolve();
      script.onerror = reject;

      try {
        doc.body.appendChild(script);
      } catch (ex) {
        reject('Fails to inject script. Possibly the document is not ready.');
      }
    });